import { render } from "./SetBranch.vue?vue&type=template&id=7e32a0c8&scoped=true"
import script from "./SetBranch.vue?vue&type=script&lang=js"
export * from "./SetBranch.vue?vue&type=script&lang=js"

import "./SetBranch.vue?vue&type=style&index=0&id=7e32a0c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e32a0c8"]])

export default __exports__